/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-08 11:08:25
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-09 16:50:11
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/Components/Options/Option/index.tsx
 */
import CountWords from '@/src/components/CountWords/CountWords';
import React from 'react';
import { Input } from 'src/components/Antd';
import { Item, Row } from 'src/components/Layouts';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Value from './Value/Value';
import css from './css.less';
const Option = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value = '',
    setLabel,
    index,
    tags = [],
    onPress,
    deleteValue,
    removeOption,
    labelError,
    labelHelp,
    valuesError,
    valuesHelp,
    onValidateLabel,
    disabled,
  } = props;
  const setValue = (v) => {
    if (setLabel) setLabel(index, v);
  };
  const onSubmit = (v) => {
    if (onPress) onPress(index, v);
  };
  const onDeleteValue = (i) => {
    if (deleteValue) deleteValue(index, i);
  };
  const deleteOption = () => {
    if (removeOption) removeOption(index);
  };
  return (
    <Row
      elements={[
        {
          child: (
            <Item
              title={`${getI18n('salesChannelProductDetail.index.option')} ${
                index + 1
              } - ${getI18n('salesChannelProductDetail.index.label')}*`}
              rightPart={<CountWords count={value.length} allCount={50} />}>
              <Input
                value={value}
                onChange={setValue}
                onBlur={onValidateLabel}
                size='large'
                error={labelError}
                help={labelHelp}
                placeholder={getI18n('salesChannelProductDetail.index.size')}
                maxLength={50}
                disabled={disabled}
              />
            </Item>
          ),
          containerClassName: css.firstContainer,
        },
        {
          child: (
            <Item
              error={valuesError}
              errorText={valuesHelp}
              title={<div>{getI18n('general.value')}</div>}
              rightSubTitle={null}
              rightPart={
                !disabled && (
                  <span className={css.remove} onClick={deleteOption}>
                    {getI18n('salesChannelProductDetail.index.deleteoption')}
                  </span>
                )
              }>
              <Value
                error={valuesError}
                tags={tags}
                disabled={disabled}
                onPress={onSubmit}
                onDeleteValue={onDeleteValue}
              />
            </Item>
          ),
          containerClassName: css.secondContainer,
        },
      ]}
    />
  );
};
export default Option;
